<template>
  <BContainer
    fluid
    class="px-0"
  >

    <BRow class="gap-y-5 mt-3">
      <BCol
        cols="12"
      >
        <h5 class="border-bottom py-2 font-weight-bold">
          <i class="fad fa-user-tie-hair" /> GROWERS
        </h5>
      </BCol>
      <BCol
        v-for="(asm, index) in asManagers.customers"
        :key="index"
        cols="12"
        md="4"
      >
        <BCard>
          <BCardTitle style="font-size: 15px; height: 30px; display: flex; align-items: center;">
            {{ asm.title }}
          </BCardTitle>
          <BCardBody
            class="p-1 d-flex justify-content-center align-items-center"
          >
            <VideoPlayer
              :src="getVideoSrc('customers', asm.src)"
              :options="{
                autoplay: false,
                controls: true
              }"
              class="border rounded-sm video-player"
            />
          </BCardBody>
        </BCard>
      </BCol>
    </BRow>

    <BRow class="gap-y-5 mt-5">
      <BCol
        cols="12"
      >
        <h5 class="border-bottom py-2 font-weight-bold">
          <i class="fad fa-list-check" /> TASKS
        </h5>
      </BCol>
      <BCol
        v-for="(asm, index) in asManagers.tasks"
        :key="index"
        cols="12"
        md="4"
      >
        <BCard>
          <BCardTitle style="font-size: 15px; height: 30px; display: flex; align-items: center;">
            {{ asm.title }}
          </BCardTitle>
          <BCardBody
            class="p-1 d-flex justify-content-center align-items-center"
          >
            <VideoPlayer
              :src="getVideoSrc('tasks', asm.src)"
              :options="{
                autoplay: false,
                controls: true
              }"
              class="border rounded-sm video-player"
            />
          </BCardBody>
        </BCard>
      </BCol>
    </BRow>

    <BRow class="gap-y-5 mt-5">
      <BCol
        cols="12"
      >
        <h5 class="border-bottom py-2 font-weight-bold">
          <i class="fad fa-list-check" /> REPORT EXTRACTIONS
        </h5>
      </BCol>
      <BCol
        v-for="(asm, index) in asManagers.exports"
        :key="index"
        cols="12"
        md="4"
      >
        <BCard>
          <BCardTitle style="font-size: 15px; height: 30px; display: flex; align-items: center;">
            {{ asm.title }}
          </BCardTitle>
          <BCardBody
            class="p-1 d-flex justify-content-center align-items-center"
          >
            <VideoPlayer
              :src="getVideoSrc('tasks', asm.src)"
              :options="{
                autoplay: false,
                controls: true
              }"
              class="border rounded-sm video-player"
            />
          </BCardBody>
        </BCard>
      </BCol>
    </BRow>

  </BContainer>
</template>
<script>
import VideoPlayer from '@/views/shared/documents/components/VideoPlayer.vue'

export default {
  name: 'SharedASMDocumentTutorials',

  components: {
    VideoPlayer
  },

  middleware: ['auth'],

  data () {
    return {
      asManagers: {
        customers: [
          {
            title: 'Verify a New Customer',
            src: 'create-customer'
          }
        ],
        tasks: [
          {
            title: 'Create and Update Task for FSO\'s',
            src: 'add-single-fso-task'
          },
          {
            title: 'Download Excel Template for Importing Multiple Tasks for a Single FSO',
            src: 'download-single-fso-task'
          },
          {
            title: 'Download Excel Template for Importing Multiple Tasks for Multiple FSO\'s',
            src: 'download-multiple-tasks'
          },
          {
            title: 'Assign/Import Tasks to Single FSO',
            src: 'import-single-fso-task'
          },
          {
            title: 'Assign/Import Tasks to Multiple FSO\'s',
            src: 'import-multiple-tasks'
          }
        ],
        exports: [
          {
            title: 'Export Tasks of FSO\'s',
            src: 'export-tasks'
          },
          {
            title: 'Export Registered Customers',
            src: 'export-customers'
          }
        ]
      }
    }
  },

  mounted () {
    // Code to run when the component is mounted
  },

  methods: {
    getVideoSrc (folder, videoName) {
      return `${window.location.origin}/videos/${folder}/${videoName}.mp4`
    }
  }
}
</script>
<style scoped>
.video-player {
  max-height: 220px;
  min-height: 220px;
  background-color: black;
  width: 100%;
}

@media  screen and (max-width: 1600px) {
  .video-player {
    max-height: 170px;
    min-height: 170px;
  }
}

@media screen and (max-width: 1200px) {
  .video-player {
    max-height: 95px;
    min-height: 95px;
  }
}

@media screen and (max-width: 516px) {
  .video-player {
    max-height: 170px;
    min-height: 170px;
  }
}
</style>
